function joinCompanyAndCustomer(companyId, customerId, locationId) {
  const url = baseUrl + "2024-10/graphql.json";
  //const url = "/admin/api/2024-10/graphql.json";

  const assignContactQuery = `
    mutation companyAssignCustomerAsContact($companyId: ID!, $customerId: ID!) {
      companyAssignCustomerAsContact(companyId: $companyId, customerId: $customerId) {
        companyContact {
          id
        }
        userErrors {
          field
          message
        }
      }
    }
  `;

  const assignRoleQuery = `
    mutation companyContactAssignRoles($companyContactId: ID!, $rolesToAssign: [CompanyContactRoleAssign!]!) {
      companyContactAssignRoles(companyContactId: $companyContactId, rolesToAssign: $rolesToAssign) {
        roleAssignments {
          id
          role {
            id
            name
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  `;

  const headers = {
    "Content-Type": "application/json",
    "apikey": apiPassword
  };

  // 1. Atribui como contato principal
  fetch(url, {
    method: "POST",
    headers,
    body: JSON.stringify({
      query: assignContactQuery,
      variables: {
        companyId,
        customerId: `gid://shopify/Customer/${customerId}`
      }
    })
  })
    .then((res) => res.json())
    .then((data) => {
      const companyContactId = data?.data?.companyAssignCustomerAsContact?.companyContact?.id;

      if (!companyContactId) {
        throw new Error("companyContactId não encontrado");
      }

      // 2. Atribui role de comprador à localização
      return fetch(url, {
        method: "POST",
        headers,
        body: JSON.stringify({
          query: assignRoleQuery,
          variables: {
            companyContactId: companyContactId,
            rolesToAssign: [
              {
                companyContactRoleId: "gid://shopify/CompanyContactRole/1911128282", // ← seu ID real da role
                companyLocationId: locationId
              }
            ]
          }
        })
      });
    })
    .then((res) => res.json())
    .then((data) => {
      console.log("Permissão atribuída na localização:", data);
       location.href = "/?cadastro-b2b";
    })
    .catch((error) => console.error("Erro:", error));
}
